<template>
  <div class="footer" :style="`background-color: ${this.footerColor};`">
    <div class="footer-content">
      <div class="footer-section">
        <a href="/" class="footer-logo">
          <div class="footer-logo-icon">
            <IconBase
              icon-name="logo-icon"
              iconColor="#444"
              viewBox="83.799 83.799 821.229 821.229"
              width="100%"
              height="100%"
              strokeWidth="0px"
              ><LogoIconBlack
            /></IconBase>
          </div>
          <div class="footer-logo-text">
            <IconBase
              icon-name="logo-text"
              iconColor="#444"
              viewBox="1072.626 310.056 2011.173 376.864"
              width="100%"
              height="100%"
              strokeWidth="0px"
              ><LogoTextBlack
            /></IconBase>
          </div>
        </a>
        <div class="footer-desc">
          50 minute 1-1 coworking sessions over video.
        </div>
      </div>
      <div class="footer-section">
        <div class="footer-title">Terms & Policies</div>
        <div class="footer-links">
          <a href="/information/privacy" class="footer-link">Privacy Policy</a>
          <a href="/information/terms" class="footer-link">Terms of Service</a>
          <a href="/information/acceptableuse" class="footer-link"
            >Acceptable Use</a
          >
          <a href="/information/cookies" class="footer-link">Cookie Policy</a>
          <a href="/information/cancellations" class="footer-link">Cancellation Policy</a>
        </div>
      </div>
      <div class="footer-section">
        <div class="footer-title">Company</div>
        <div class="footer-links">
          <a href="/about" class="footer-link">About Us</a>
          <a href="/pricing" class="footer-link">Pricing</a>
          <a href="/affiliate-program" class="footer-link">Affiliate Program</a>
          <!-- <a href="/information/privacy" class="footer-link">Manifesto</a> -->
        </div>
      </div>
      <div class="footer-section">
        <div class="footer-title">Help & Contact</div>
        <div class="footer-links">
          <div class="footer-link">Contact us at:</div>
          <div>hello@cofocus.one</div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div>Copyright © 2024 ElysiumOne OÜ. All rights reserved.</div>
    </div>
  </div>
</template>

<script>
import IconBase from "../../../components/IconBase";
import LogoIconBlack from "../../../components/SVG/LogoIconBlack";
import LogoTextBlack from "../../../components/SVG/LogoTextBlack";

export default {
  name: "Footer",
  props: {
    footerColor: {
      type: String,
      default: "#fff",
    },
  },
  components: {
    IconBase,
    LogoIconBlack,
    LogoTextBlack,
  },
};
</script>

<style scoped>
.footer {
  width: 100%;
  padding: 120px 0px 60px;
}
.footer-content {
  width: 800px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.footer-section {
  width: 200px;
  margin: 0px 14px;
}
.footer-links {
  display: inline-flex;
  flex-direction: column;
}
.footer-link {
  margin: 12px 0px;
  display: inline-block;
}
.footer-link:hover {
  color: #666;
}
.footer-title {
  font-size: 18px;
  font-weight: 600;
  padding-bottom: 14px;
}

.footer-logo {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 4px;
  margin-left: 10px;
  transform: scale(1.2);
  margin-bottom: 18px;
}
.footer-logo-icon {
  width: 25px;
  height: 25px;
}
.footer-logo-text {
  height: 13px;
  width: 84px;
}
.footer-bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 50px 0px 20px;
}
.footer-desc {
  line-height: 18px;
}

@media screen and (max-width: 800px) {
  .footer-content {
    width: unset;
    flex-wrap: wrap;
  }
  .footer-section {
    margin-bottom: 30px;
  }
}
</style>